var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0091 12.8447L19.6547 17.2492L19.9544 17.5524C22.4048 17.374 23.8034 20.5362 22.0287 22.2719C20.307 24.067 17.1984 22.6582 17.3629 20.1737L17.0632 19.8705L12.7089 24.275C12.6823 24.3031 12.6503 24.3254 12.615 24.3406C12.5796 24.3559 12.5416 24.3637 12.5032 24.3637C12.4648 24.3637 12.4267 24.3559 12.3914 24.3406C12.356 24.3254 12.3241 24.3031 12.2975 24.275L7.94315 19.8705L7.64346 20.1737C7.81975 22.6464 4.68179 24.067 2.97765 22.2719C1.203 20.5541 2.61332 17.3621 5.052 17.5524L5.35169 17.2492L0.997325 12.8447C0.879798 12.7258 0.879798 12.5416 0.997325 12.4227L5.55736 7.81015C5.71602 7.64966 5.91582 7.73288 6.0451 7.87554C6.25664 8.11924 6.79139 8.52343 6.73263 8.72553C6.48582 10.7168 9.00677 11.9353 10.3877 10.4909C11.8157 9.09405 10.611 6.55003 8.64244 6.79373C8.43676 6.85317 8.0548 6.31821 7.80212 6.09828C7.64933 5.98535 7.57882 5.76542 7.7316 5.61088L12.2916 0.99834C12.4092 0.87946 12.5913 0.87946 12.7089 0.99834L17.0632 5.40284L17.3629 5.09969C17.1984 2.61511 20.3128 1.20638 22.0287 3.00146C23.8034 4.73711 22.4048 7.89337 19.9544 7.72099L19.6547 8.02414L24.0091 12.4286C24.1266 12.5475 24.1266 12.7318 24.0091 12.8507V12.8447Z",
    fill: "url(#paint0_linear_6126_18671)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6126_18671",
    x1: 12.5032,
    y1: 0.90918,
    x2: 12.5032,
    y2: 24.3637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07B9CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#3969E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D2AE7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAction);
export default __webpack_public_path__ + "static/media/action.5f45545a713463f95d8fa07fea094633.svg";
export { ForwardRef as ReactComponent };